import { render } from "./TextViewdy.vue?vue&type=template&id=cbcca9aa"
import script from "./TextViewdy.vue?vue&type=script&lang=js"
export * from "./TextViewdy.vue?vue&type=script&lang=js"

import "./TextViewdy.vue?vue&type=style&index=0&id=cbcca9aa&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__